import { pluginKey } from './plugin-key';
export var search = function search(_ref) {
  var query = _ref.query,
    category = _ref.category,
    disableDefaultItems = _ref.disableDefaultItems,
    featuredItems = _ref.featuredItems;
  return function (_ref2) {
    var tr = _ref2.tr;
    return tr.setMeta(pluginKey, {
      searchOptions: {
        query: query,
        category: category,
        disableDefaultItems: disableDefaultItems,
        featuredItems: featuredItems
      }
    });
  };
};